export default "__VITE_ASSET__D8DG9fCk__"